var map = {
	"./Client.vue": [
		"./src/views/wallet/Client.vue",
		"src_views_wallet_Client_vue"
	],
	"./forClient/ClientBrand.vue": [
		"./src/views/wallet/forClient/ClientBrand.vue",
		"src_views_wallet_forClient_ClientBrand_vue"
	],
	"./forClient/NewTemplate.vue": [
		"./src/views/wallet/forClient/NewTemplate.vue",
		"src_composables_file-list_js",
		"src_components_UI_imageTransform_DropZone_vue-src_components_UI_imageTransform_components_Ver-3298a4",
		"src_components_UI_imageTransform_ImageInputBase64_vue",
		"src_components_UI_datepicker_DatePicker_vue",
		"src_views_wallet_forClient_NewTemplate_vue"
	],
	"./forClient/NewsTemplate.vue": [
		"./src/views/wallet/forClient/NewsTemplate.vue",
		"src_components_UI_modals_VModal_vue-_4f69",
		"src_utils_i18nLocale_js-src_components_UI_buttons_NewButton_vue-src_components_app_content_te-a1278a",
		"src_views_wallet_forClient_NewsTemplate_vue"
	],
	"./forClient/QWallet.vue": [
		"./src/views/wallet/forClient/QWallet.vue",
		"src_components_UI_modals_VModal_vue-_4f69",
		"src_components_app_header_Header_vue",
		"src_components_UI_modals_CheckSaveData_vue",
		"src_composables_file-list_js",
		"src_components_UI_imageTransform_DropZone_vue-src_components_UI_imageTransform_components_Ver-3298a4",
		"src_views_catalog_Huawei_vue",
		"src_views_catalog_Google_vue",
		"src_views_catalog_Apple_vue",
		"src_views_catalog_Preview_vue",
		"src_services_storage_service_js-src_services_wallet_service_js-src_components_UI_selects_UiSe-05ed05",
		"src_components_UI_imageTransform_QImageInputBase64_vue",
		"src_views_wallet_forClient_QWallet_vue"
	],
	"./forClient/QrCode.vue": [
		"./src/views/wallet/forClient/QrCode.vue",
		"src_views_wallet_forClient_QrCode_vue"
	],
	"./forClient/STemplate.vue": [
		"./src/views/wallet/forClient/STemplate.vue",
		"src_components_UI_modals_VModal_vue-_4f69",
		"src_utils_i18nLocale_js-src_components_UI_buttons_NewButton_vue-src_components_app_content_te-a1278a",
		"src_views_wallet_forClient_STemplate_vue"
	],
	"./forClient/Wallet.vue": [
		"./src/views/wallet/forClient/Wallet.vue",
		"src_components_UI_modals_VModal_vue-_4f69",
		"src_components_app_header_Header_vue",
		"src_components_UI_modals_CheckSaveData_vue",
		"src_composables_file-list_js",
		"src_components_UI_imageTransform_DropZone_vue-src_components_UI_imageTransform_components_Ver-3298a4",
		"src_components_UI_imageTransform_ImageInputBase64_vue",
		"src_views_catalog_Huawei_vue",
		"src_views_catalog_Google_vue",
		"src_views_catalog_Apple_vue",
		"src_views_catalog_Preview_vue",
		"src_services_storage_service_js-src_services_wallet_service_js-src_components_UI_selects_UiSe-05ed05",
		"src_views_wallet_forClient_Wallet_vue"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = "./src/views/wallet lazy recursive ^\\.\\/.*\\.vue$";
module.exports = webpackAsyncContext;